import "core-js/modules/es7.object.get-own-property-descriptors";
import "core-js/modules/es6.symbol";
import "core-js/modules/web.dom.iterable";
import "core-js/modules/es6.array.iterator";
import "core-js/modules/es6.object.to-string";
import "core-js/modules/es6.object.keys";
import "core-js/modules/es6.object.assign";
import _defineProperty from "/opt/build/repo/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import { useMemo as t, useCallback as e, createElement as o, Fragment as a } from "react";

var p = function p(_ref) {
  var t = _ref.type;
  throw new Error("Could not find a component mapping for type \"".concat(t, "\""));
},
    n = function n(_n) {
  var r = _n.getKey,
      i = _n.getType,
      _n$list = _n.list,
      m = _n$list === void 0 ? [] : _n$list,
      s = _n.map,
      u = _n.meta,
      l = _n.mapDataToContext,
      v = _n.mapDataToProps,
      _n$default = _n.default,
      d = _n$default === void 0 ? p : _n$default,
      y = _n.defaultMapDataToContext,
      x = _n.defaultMapDataToProps,
      c = t(function () {
    return m.map(r);
  }, [m, r]),
      C = t(function () {
    return m.map(i);
  }, [m, i]),
      T = t(function () {
    return C.map(function (t) {
      var e;
      return null !== (e = s[t]) && void 0 !== e ? e : d;
    });
  }, [C, s, d]),
      f = e(function (t) {
    return {
      list: m,
      keys: c,
      types: C,
      comps: T,
      map: s,
      meta: u,
      index: t,
      data: m[t],
      key: c[t],
      type: C[t],
      Comp: T[t],
      previousData: m[t - 1],
      previousKey: c[t - 1],
      previousType: C[t - 1],
      PreviousComp: T[t - 1],
      nextData: m[t + 1],
      nextKey: c[t + 1],
      nextType: C[t + 1],
      NextComp: T[t + 1]
    };
  }, [T, c, C, u, m, s]),
      D = t(function () {
    return m.map(function (t, e) {
      var o;
      var a = null !== (o = null == l ? void 0 : l[C[e]]) && void 0 !== o ? o : y;
      return a ? a(f(e)) : void 0;
    });
  }, [f, m, l, C, y]),
      g = e(function (t) {
    return _objectSpread(_objectSpread({}, f(t)), {}, {
      contexts: D,
      context: D[t],
      previousContext: D[t - 1],
      nextContext: D[t + 1]
    });
  }, [f, D]),
      k = t(function () {
    return m.map(function (t, e) {
      var o;
      var a = null !== (o = null == v ? void 0 : v[C[e]]) && void 0 !== o ? o : x;
      return a ? a(g(e)) : void 0;
    });
  }, [g, m, v, C, x]);
  return o(a, null, k.map(function (t, e) {
    var a = T[e];
    return o(a, Object.assign(_objectSpread({
      key: c[e]
    }, t), a === d ? {
      type: C[e]
    } : void 0));
  }));
};

export { n as MapToComponents };